module.exports = __webpack_public_path__ + "static/media/btnDescargaGrey.71cbba3d.png";